import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import WarningIcon from '@mui/icons-material/WarningRounded';

const styles = theme => ({
    button: {
        padding: 0,
        marginLeft: 5,
        cursor: 'default'
    },
    icon: {
        fontSize: 18,
        color: theme.palette.warning.main
    }
});

class WarningButton extends React.Component {
    render() {
        const { classes, title, placement } = this.props

        return (
            <Tooltip
                title={title}
                placement={placement ? placement : 'top'}
                arrow
            >
                <IconButton
                    className={classes.button}
                    disableRipple
                    aria-label='Show warning text'
                    size="large"
                >
                    <WarningIcon
                        className={classes.icon}
                    />
                </IconButton>
            </Tooltip>
        );
    }
}

export default withStyles(WarningButton, styles);